import { cn } from "@newxsystems/shared";
import type { IRavioliSectionProps } from "./RavioliSection.props";

export const RavioliSection = ({
  children,
  className,
  containerClassName,
  containerWidth = "default",
  id,
  spacing,
}: IRavioliSectionProps) => (
  <section
    className={cn("ravioli-block-spacing bg-background text-foreground", className)}
    data-spacing={spacing || undefined}
    id={id || undefined}
  >
    <div
      className={cn("ravioli-container", containerClassName)}
      data-container-width={containerWidth}
    >
      {children}
    </div>
  </section>
);

RavioliSection.displayName = "Content::RavioliSection";
